export default __webpack_public_path__ + "static/golden-hour-af82cdb17354e7a02855a3ef668b81da.webp";